module.exports = __webpack_public_path__ + "static/media/Move Down Red.d5e75514.svg";